import React, { useEffect, useState } from 'react';
import { 
    Box, 
    Flex,
    Text,
    Accordion
 } from '@chakra-ui/react';
 import DetailsContent from './DetailsContent';

interface Details {
    name: string;
    html: any;
}

const DetailsBlock = ({details, video, color}: 
    {
        details: Details[], 
        video: any, 
        color: string
    }) => {
    const [src, setSrc] = useState<string | null>(null); 

    useEffect(() => {
        if (video){
            const srcRegex = /src="([^"]+)"/;
            const match = video.match(srcRegex);
            if (match) {
                setSrc(match[1]);
            }
        }
    }, [])

    return(
        <Box>
            <Text as='b' fontSize='26px'>
                Подробная информация
            </Text>
            <Box mt='20px'>
                <Accordion allowMultiple>
                    {details.map((block, i) => {
                        if (!block.html){
                            return ;
                        }
                        return (
                            <DetailsContent 
                                name={block.name} 
                                text={block.html}
                                blockId={i}
                                color={color}
                            />
                        )
                    })}
                </Accordion>
            </Box>
            {src && (
                <Flex
                    mt={20} 
                    justifyContent='center'
                >
                    <iframe width="80%" height="405px" src={src} allow="clipboard-write; autoplay"></iframe>
                </Flex>
            )}
        </Box>
    )
}

export default DetailsBlock;